import showView from "../views/index";

const loggedIn = () => {
    showView('NAV');
    showView('NAV_BOTTOM'); 
    showView('NAV2');   
}

export default loggedIn;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/loggedIn.js